import { getAccessToken, signOut, useAuth, type AuthStatus } from "../auth";
import { config } from "../config";
import { usePlans } from "../store";
import { createPlansApi, createShareApi } from "./api";
import { SyncEngine, useSyncStatus } from "./engine";

let engine: SyncEngine | undefined;

export const shareApi = createShareApi(config.apiUrl, getAccessToken);

/** Saves pending changes to the account now (e.g. before sharing a plan). */
export function flushSync(): Promise<void> {
  return engine?.flush() ?? Promise.resolve();
}

/** Runs the sync engine while the user is signed in. */
export function startSync(): void {
  const update = (status: AuthStatus) => {
    if (status === "signed-in") {
      engine ??= new SyncEngine(createPlansApi(config.apiUrl, getAccessToken));
      void engine.start();
    } else {
      engine?.stop();
    }
  };
  update(useAuth.getState().status);
  useAuth.subscribe((state, prev) => {
    if (state.status !== prev.status) update(state.status);
  });
}

/**
 * Saves outstanding changes, then signs out and clears plans from this browser.
 * They stay in the account. If changes couldn't be saved, asks before discarding them.
 */
export async function signOutAndClear(
  confirmDiscard: () => boolean = () =>
    window.confirm("Some changes haven't been saved to your account. Sign out anyway?"),
): Promise<void> {
  if (engine) {
    await engine.flush();
    if (useSyncStatus.getState().status !== "synced" && !confirmDiscard()) return;
    engine.stop();
  }
  usePlans.getState().reset();
  await signOut();
}
